export default "__VITE_ASSET__YjOTNDct__"